import styled from '@emotion/styled';

export const ImgRenderer = styled.img`
  display: block;
  max-width: 100%;
  margin-inline: auto;
  object-fit: cover;
`;
